export const sameDrive = (first, second) =>
    first != null && second != null && Number(first) > 0 && String(first) === String(second);

export function parseLocation(location) {
    if (location?.lat == null || location?.lng == null ||
        location.lat === '' || location.lng === '') return null;
    const lat = Number(location.lat);
    const lng = Number(location.lng);
    return Number.isFinite(lat) && Number.isFinite(lng) &&
        Math.abs(lat) <= 90 && Math.abs(lng) <= 180 ? { lat, lng } : null;
}

export function updateDriverPosition(driver, driveNo, location) {
    const position = parseLocation(location);
    return position && sameDrive(driver?.DriveNo, driveNo)
        ? { ...driver, ...position } : driver;
}
